import styles from 'style-guide/TypographyGuide.module.css';

interface CaptionProps {
  text: string;
  textColor?: string;
}

export const Caption = ({ text, textColor }: CaptionProps) => {
  return (
    <h4 className={`${styles.caption_one}`} style={{ color: textColor }}>
      {text}
    </h4>
  );
};
